import { NgModule } from '@angular/core';
import { SharedModule } from 'src/app/shared/shared.module';
import { PlanejamentoFormComponent } from './planejamento-form.component';

@NgModule({
    declarations: [
        PlanejamentoFormComponent
    ],
    imports: [
        SharedModule,
    ],
    exports: [
        PlanejamentoFormComponent
    ]
})

export class PlanejamentoModule { }
